import React, { useState, useEffect } from 'react';
import { getPokemonSpriteUrl } from '../../api/pokeApi';

const TeamNameWithTooltip = ({ teamName, team, generateName }) => {
  const [teamSprites, setTeamSprites] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  
  useEffect(() => {
    const loadSprites = async () => {
      if (!team || team.length === 0) return;
      
      const pokemonList = Array.isArray(team) ? team : team.split(',').map(p => p.trim());
      const sprites = await Promise.all(
        pokemonList.slice(0, 6).map(async (pokemon) => {
          try {
            const url = await getPokemonSpriteUrl(pokemon);
            return { name: pokemon, url };
          } catch (err) {
            console.warn(`Failed to load sprite for ${pokemon}`);
            return { 
              name: pokemon, 
              url: 'https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/25.png' 
            };
          }
        })
      );
      
      setTeamSprites(sprites);
    };
    
    if (showTooltip && teamSprites.length === 0) {
      loadSprites();
    }
  }, [team, showTooltip]);
  
  const displayName = teamName || (generateName ? generateName(team) : 'Unnamed Team');
  
  return (
    <div 
      className="team-name-wrapper"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className="deck-name" style={{ cursor: 'pointer' }}>
        {displayName}
      </span>
      
      {showTooltip && (
        <div className="team-tooltip">
          <div className="team-tooltip-title">Team Composition</div>
          <div className="team-tooltip-sprites">
            {teamSprites.map((sprite, idx) => (
              <div key={idx} className="team-tooltip-sprite">
                <img 
                  src={sprite.url} 
                  alt={sprite.name}
                  title={sprite.name}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamNameWithTooltip;